import { Country, State, City } from 'country-state-city';
const countries = require('country-list');

// Countries to exclude from the list
export const EXCLUDED_COUNTRIES = ['IL', 'IR', 'EH']; // IL for Israel, IR for Iran, EH for Western Sahara

// Countries that require state selection
export const COUNTRIES_WITH_STATES = ['US', 'CA', 'IN', 'AU', 'BR', 'UAE']; // Add more as needed

// Get country name from code using the country-list package
export const getCountryName = (countryCode) => {
    try {
        // Try first with country-list
        const name = countries.getName(countryCode);
        if (name) return name;
        
        // Fall back to country-state-city if not found
        return getFilteredCountries().find(c => c.isoCode === countryCode)?.name || countryCode;
    } catch (error) {
        return countryCode;
    }
};

// Get country list for basic selectors
export const getCountryList = () => {
    try {
        return countries.getNameList();
    } catch (error) {
        return {};
    }
};

// Get filtered list of countries
export const getFilteredCountries = () => {
    return Country.getAllCountries()
        .filter(country => !EXCLUDED_COUNTRIES.includes(country.isoCode));
};

// Get states for a country
export const getStatesForCountry = (countryCode) => {
    if (!countryCode || !COUNTRIES_WITH_STATES.includes(countryCode)) {
        return [];
    }
    return State.getStatesOfCountry(countryCode);
};

// Get cities for a country or state
export const getCitiesForLocation = (countryCode, stateCode = null) => {
    if (!countryCode) return [];
    
    if (COUNTRIES_WITH_STATES.includes(countryCode)) {
        if (!stateCode) return [];
        return City.getCitiesOfState(countryCode, stateCode) || [];
    }
    
    return City.getCitiesOfCountry(countryCode) || [];
};

// Transform city name if needed (e.g., Asilah to Assilah)
export const transformCityName = (cityName) => {
    if (cityName === 'Asilah') return 'Assilah';
    return cityName;
}; 